<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'services-01' },
})
</script>

<template>
  <section class="b2-services" :class="`variant-${variant}`">
    <div class="b2-section-intro">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
      <p class="b2-section-sub">{{ content.sub.value }}</p>
    </div>
    <div class="b2-services-grid">
      <div v-for="s in content.items.value" :key="s.title" class="b2-service-card">
        <div class="b2-service-icon"><v-icon>{{ s.icon }}</v-icon></div>
        <h3>{{ s.title }}</h3>
        <p>{{ s.description }}</p>
        <a href="#contact" class="b2-service-link">Learn more →</a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.b2-services { padding: 100px 40px; max-width: 1200px; margin: 0 auto; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin-bottom: 16px; }
.b2-section-sub { font-size: 16px; color: #555; max-width: 560px; line-height: 1.7; margin-bottom: 48px; }
.b2-services-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 28px; }
.b2-service-card { padding: 32px 26px; border: 1px solid #e8f0e4; border-radius: 4px; transition: box-shadow .2s, transform .2s, border-color .2s; }
.b2-service-card:hover { box-shadow: 0 8px 40px rgba(74,140,63,.12); transform: translateY(-4px); border-color: #b8d9b2; }
.b2-service-icon { font-size: 34px; margin-bottom: 16px; }
.b2-service-card h3 { font-family: 'Playfair Display', serif; font-size: 20px; color: #1a3320; margin-bottom: 10px; }
.b2-service-card p { font-size: 15px; color: #666; line-height: 1.65; margin-bottom: 18px; }
.b2-service-link { font-size: 13px; font-weight: 500; color: #4a8c3f; text-decoration: none; }
.b2-service-link:hover { text-decoration: underline; }
.variant-services-02 .b2-services-grid { grid-template-columns: 1fr; gap: 0; border-top: 1px solid #dce7da; }
.variant-services-02 .b2-service-card { display: grid; grid-template-columns: 56px minmax(160px, .55fr) 1fr auto; align-items: center; gap: 20px; border: 0; border-bottom: 1px solid #dce7da; border-radius: 0; padding: 24px 8px; }
.variant-services-02 .b2-service-card:hover { box-shadow: none; transform: translateX(5px); }
.variant-services-02 .b2-service-icon, .variant-services-02 .b2-service-card h3, .variant-services-02 .b2-service-card p { margin: 0; }
.variant-services-03 { max-width: none; background: #1a3320; color: white; }
.variant-services-03 .b2-section-intro, .variant-services-03 .b2-services-grid { max-width: 1120px; margin-left: auto; margin-right: auto; }
.variant-services-03 .b2-section-title { color: white; }
.variant-services-03 .b2-section-sub { color: rgba(255,255,255,.68); }
.variant-services-03 .b2-service-card { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.12); }
.variant-services-03 .b2-service-card h3 { color: white; }
.variant-services-03 .b2-service-card p { color: rgba(255,255,255,.7); }
@media (max-width: 680px) {
  .variant-services-02 .b2-service-card { grid-template-columns: 44px 1fr; }
  .variant-services-02 .b2-service-card p, .variant-services-02 .b2-service-link { grid-column: 2; }
}
</style>
